module.exports = __webpack_public_path__ + "static/credit-poor-0723fb6c7d9456a9d30a242a18be4b1f.png";